export default __webpack_public_path__ + "static/media/Carosel HO 2.fa41e960.svg";